// Module
var code = "<button class=\"btn btn-link\" ng-click=\"print()\"> <i class=\"fa fa-print\"></i> Print </button> ";
// Exports
module.exports = code;